import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SuccessNotification = ({ isVisible, entry, onClose }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible || !entry) return null;

  return (
    <div className="fixed top-[120px] right-24 z-250 animate-in slide-in-from-right duration-300">
      <div className="bg-card rounded-lg shadow-elevation-4 border border-border w-[320px] md:w-[380px] overflow-hidden">
        <div className="bg-success/10 border-b border-success/20 px-24 py-18">
          <div className="flex items-center gap-12">
            <div className="w-[36px] h-[36px] bg-success/20 rounded-lg flex items-center justify-center">
              <Icon name="CheckCircle2" size={20} color="var(--color-success)" strokeWidth={2} />
            </div>
            <div className="flex-1">
              <h4 className="font-heading font-semibold text-sm md:text-base text-success">
                Entry Validated Successfully
              </h4>
            </div>
            <button
              onClick={onClose}
              className="w-[28px] h-[28px] flex items-center justify-center rounded-lg hover:bg-success/20 transition-smooth"
              aria-label="Close notification"
            >
              <Icon name="X" size={16} color="var(--color-success)" strokeWidth={2} />
            </button>
          </div>
        </div>

        <div className="px-24 py-18 space-y-12">
          <div className="flex items-center justify-between">
            <span className="font-caption text-xs text-muted-foreground uppercase tracking-wide">
              Tracking Number
            </span>
            <span className="font-mono text-sm text-foreground font-medium">
              {entry?.trackingNumber}
            </span>
          </div>

          <div className="flex items-center justify-between">
            <span className="font-caption text-xs text-muted-foreground uppercase tracking-wide">
              Carrier
            </span>
            <span className="font-body text-sm text-foreground font-medium">
              {entry?.carrier}
            </span>
          </div>

          <div className="flex items-center justify-between">
            <span className="font-caption text-xs text-muted-foreground uppercase tracking-wide">
              Entry ID
            </span>
            <span className="font-mono text-xs text-muted-foreground">
              {entry?.entryId}
            </span>
          </div>

          <div className="pt-12 border-t border-border">
            <div className="flex items-center gap-8">
              <Icon name="Clock" size={14} color="var(--color-muted-foreground)" strokeWidth={2} />
              <span className="font-caption text-xs text-muted-foreground">
                {new Date(entry.timestamp)?.toLocaleString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessNotification;